import { Dialog, Pane } from 'evergreen-ui';
import DiaryEntryForm from './DiaryEntryForm';

const DescriptionDialog = ({ isShown, onClose, onSave, userId, selectedDate}) => {
  const handleEntryAdded = async () => {
    if (onSave) await onSave();
    if (onClose) onClose();
  };

  return (
    <Dialog
      isShown={isShown}
      title="Aggiungi descrizione giornata"
      onCloseComplete={onClose}
      hasFooter={false}
      shouldAutoFocus={false}
    >
      <Pane>
        <DiaryEntryForm onEntryAdded={handleEntryAdded} userId={userId} selectedDate={selectedDate} />
      </Pane>
    </Dialog>
  );
};

export default DescriptionDialog;
